import { TranslateModule } from "@ngx-translate/core";

import { AddDeviceFormComponent } from "./add-device-form/add-device-form.component";
import { BehaviorSubject } from "rxjs";
import {
  Component,
  Output,
  EventEmitter,
  Input,
  ChangeDetectionStrategy
} from "@angular/core";

@Component({
    selector: "device-add",
    templateUrl: "./device-add.component.html",
    styleUrls: ["./device-add.component.css"],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [
    TranslateModule,
    AddDeviceFormComponent
]
})
export class DeviceAddComponent {
  @Output() closeAddFormEvent = new EventEmitter<void>();
  @Output() deviceAddedEvent = new EventEmitter<string>();

  @Input("locationList") locations: any;

  addDevFormError$ = new BehaviorSubject<string>("");
  addDevFormInfo$ = new BehaviorSubject<string>("");
}
